import React from "react";
import Classes from "./styles/style.module.css";

const LeaderBordSelect = ({ type, handleChange }) => {
  return (
    <div className={Classes.TabContainer}>
      <button
        onClick={() => handleChange("monthly")}
        className={`${Classes.tab} ${
          type === "monthly" ? Classes.activeTab : ""
        }`}
      >
        کتاب ۱۵
      </button>
      <button
        onClick={() => handleChange("allTimes")}
        className={`${Classes.tab} ${
          type === "allTimes" ? Classes.activeTab : ""
        }`}
      >
        همه زمان‌ها
      </button>
    </div>
  );
};

export default LeaderBordSelect;
